import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../auth/useAuth'

import DspTable from './DspTable'

import {
  getLineItems,
} from '../../redux/actions/dsp'
import { calcDerivedMetrics } from '../../services/dspHelper'

const initialColumns = [
  { key: 'lineItem', name: 'Line Item', fixed: true, width: 200, resizable: true }
]

const DspLineItemTable = ({ selectedDspAccount, currentAdvertiser }) => {
  const dispatch = useDispatch()
  const { getAccessTokenSilently } = useAuth()

  const currentStartDate = useSelector(state => state.header.currentStartDate)
  const currentEndDate = useSelector(state => state.header.currentEndDate)

  const campaignColumns = useSelector(state => state.dsp.campaignColumns)

  const [isLoading, setIsLoading] = useState(false)
  const [lineItemList, setLineItemList] = useState([])

  useEffect(() => {
    if (selectedDspAccount) {
      loadData()
    }
  }, [selectedDspAccount, campaignColumns, currentStartDate, currentEndDate]) // eslint-disable-line

  const loadData = async () => {
    const accessToken = await getAccessTokenSilently()
    setIsLoading(true)
    const list = await dispatch(getLineItems(
      accessToken,
      selectedDspAccount,
      campaignColumns
    ))
    setLineItemList(list.map(record => ({
      lineItem: record.line_item_name,
      ...calcDerivedMetrics(record),
    })))
    setIsLoading(false)
  }

  const columns = useMemo(() => {
    return [
      ...initialColumns,
      ...campaignColumns,
    ]
  }, [campaignColumns])

  const filteredLineItems = useMemo(() => lineItemList.filter(
    l => !currentAdvertiser || currentAdvertiser.advertiserId === l.advertiser_id
  ), [lineItemList, currentAdvertiser])

  return (
    <div className="dsp-content">
      <DspTable
        columns={columns}
        data={filteredLineItems}
        loading={isLoading}
        autoHeight
        sortColumn="impressions"
        sortType="desc"
        searchField="lineItem"
      />
    </div>
  )
}

export default DspLineItemTable
